export default __webpack_public_path__ + "static/media/logo-no-text.fc13e94a.png";